export const enum StatusTypeEnum {
  FAILED = "failed",
  SUCCESS = "success",
}

export type StatusType = "failed" | "success";
